import { createStyles } from "antd-style";

export const useBodyStyles = createStyles(({ token, css }: any) => ({
  section: css`
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
  `,
  body: css``,
  tableButtonSelect: css`
    max-width: 240px;
  `,
  tableContainer: css`
    min-height: 240px;
  `,
  tableRow: css`
    cursor: pointer;
  `,
}));
